import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { SIGNIN, GET_APP_URL } from "./types";
var INITIAL_STATE = {
  authenticated: false,
  requesting: false,
  failed: false,
  profile: false,
  appUrl: false,
  appUrlRequesting: false
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SIGNIN.REQUEST:
      {
        return _objectSpread({}, state, {
          authenticated: false,
          requesting: true,
          failed: false,
          profile: false
        });
      }

    case SIGNIN.FAIL:
      {
        return _objectSpread({}, state, {
          authenticated: false,
          requesting: false,
          failed: true,
          profile: false
        });
      }

    case SIGNIN.SUCCESS:
      {
        return _objectSpread({}, state, {
          authenticated: true,
          requesting: false,
          failed: false,
          profile: action.payload
        });
      }

    case GET_APP_URL.REQUEST:
      {
        return _objectSpread({}, state, {
          appUrlRequesting: true,
          appUrl: false
        });
      }

    case GET_APP_URL.FAIL:
      {
        return _objectSpread({}, state, {
          appUrl: false,
          appUrlRequesting: false
        });
      }

    case GET_APP_URL.SUCCESS:
      {
        return _objectSpread({}, state, {
          appUrl: action.payload,
          appUrlRequesting: false
        });
      }

    default:
      {
        return state;
      }
  }
});